
































































































































































import ICompanyContacts from '@/store/models/ICompanyContacts';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class CompanyContactsSelector extends Vue {
    searchCompanyContacts: string = "";
    isValid: boolean = true;
    dialog: boolean = false;
    headers: any = [
        { text: 'Name',
            align: 'start',
            value: 'name'
        },
        { text: 'Email', value: 'email' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : ICompanyContacts = {
        id: "",
        name: "",
        email: "",
        prefix: "",
        idListPhonePrefix: "",
        phoneNumber: "",
        idCompany: ""
    }
    defaultItem : any = {
        id: "",
        name: "",
        email: "",
        prefix: "",
        idListPhonePrefix: "",
        phoneNumber: "",
        idCompany: ""
    }
    sortBy: string = 'name';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    CompanyContactsList !: ICompanyContacts[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix !: IListPhonePrefix[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedCompanyContact : ICompanyContacts[] = [];
    selectedPhonePrefix: any = null;
    phonePrefixCountry : string[] = [];

    get ListPhonePrefixesSort () {
        return this.ListPhonePrefix.sort((n1, n2) => {
            if (n1.country > n2.country) {
                return 1;
            }

            if (n1.country < n2.country) {
                return -1;
            }

            return 0;
        });
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Company Contact' : 'Edit Company Contact'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    editCompanyContacts (item: any, dbox = true) {
        if (this.selectedCompanyContact.length > 0) {
            this.editedIndex = this.CompanyContactsList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedPhonePrefix = this.ListPhonePrefix.find(p => p.id === this.editedItem.idListPhonePrefix);
            this.dialog = true;
        }
    }

    saveCompanyContacts (companyContact: ICompanyContacts) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountryPrefix();
            if (this.editedIndex > -1) {
                this.$emit('editCompanyContact', this.editedItem);
                Object.assign(this.CompanyContactsList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveCompanyContact', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteCompanyContacts (companyContact: ICompanyContacts) {
        if (this.selectedCompanyContact.length > 0) {
            this.$emit('deleteCompanyContact', companyContact);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    select(item : ICompanyContacts) : void {
        let index : number = this.selectedCompanyContact.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedCompanyContact = [item];
        } else {
            let companyContact = this.selectedCompanyContact.find(w => w.id === item.id);
            if (!companyContact) {
                this.selectedCompanyContact = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
